import { buildBoss } from '../builders';
import background from './backgrounds/Motherlode.jpg';

export default buildBoss({
  id: 61594,
  name: 'The MOTHERLODE!!',
  background,
});
